import { $vfm } from 'vue-final-modal'
import SignInDialog from '../apps/account/SignInDialog.vue';

export default {
    showSignIn(params){
        $vfm.show({
            component: SignInDialog,
            bind:params
        });
    }
}